var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"new-agent-page"}},[_c('b-tabs',[_c('b-tab-item',{attrs:{"label":"Información del Agente"}},[_c('AgentForm')],1),_c('b-tab-item',{attrs:{"label":"Historial del Agente"}},[_c('AgentTimeline')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }